<template>
    <div class="search">
        <div class="box" v-clickoutside="handleClose">
            <form>
                <span class="select" @click.prevent="handleClick">{{message}}</span>
                <a href="#">搜索</a>
            </form>
        </div>
        <ul class="sub" v-show="show">
            <li v-for="item in lists" :key="item.mes" :class="{hover:item.isActive}"
            @mouseover="handleOver(item)"
            @mouseout="handleOut(item)"
            @click="handleSubClick(item)"
            >
                {{item.mes}}
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data(){
        return{
            message:'请选择游戏名称',
            show:false,
            lists:[
                {
                    mes:'地下城与勇士',
                    isActive:false
                },
                {
                    mes:'魔兽世界（国服）',
                    isActive:false
                },
                {
                    mes:'魔兽世界（台服）',
                    isActive:false
                },
                {
                    mes:'热血江湖',
                    isActive:false
                },
                {
                    mes:'神鬼传奇',
                    isActive:false
                },
                {
                    mes:'大话西游II',
                    isActive:false
                },
                {
                    mes:'QQ幻想世界',
                    isActive:false
                },
            ]
        }
    },
    methods:{
        handleClose(){
            this.show=false
        },
        handleClick(){
            this.show=this.show===false ? true : false
        },
        handleOver(item){
            item.isActive=true
        },
        handleOut(item){
            item.isActive=false
        },
        handleSubClick(item){
            this.message=item.mes;
            this.show=false
        },
        
    },
    directives:{
        clickoutside:{
            bind(el,binding,vnode){
                function documentHandler(e){
                    if(el.contains(e.target)){
                        return false
                    }
                    if(binding.expression){
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__=documentHandler;
                document.addEventListener('click',documentHandler);
            },
            unbind(el,binding){
                document.removeEventListener('click',el.__vueClickOutside__);
                delete el.__vueClickOutside__;
            }
        }
    }
}
</script>
<style>
html,body{
    height: 100%;
    overflow: hidden;
}
body,div,form,h2,ul,li{
    margin: 0;
    padding: 0;
}
ul{
    list-style-type: none;
}
body{
    background:#23384e;
    font:12px/1.5 \5fae\8f6f\96c5\9ed1;
}
.search, .search form, .search .box, .search .select, .search a{
    background: url(./assets/lesson5/search.jpg) no-repeat;
}
.search, .search .box, .search form{
    height: 34px;
}
.search{
    position: relative;
    width: 350px;
    margin: 10px auto;
}
.search .box{
    background-position: right 0;
}
.search form{
    background-repeat: repeat-x;
    background-position: 0 -34px;
    margin: 0 20px 0 40px;
}
.search .select{
    float: left;
    color: #fff;
    width: 190px;
    height: 22px;
    cursor: pointer;
    margin-top: 4px;
    line-height: 22px;
    padding-left: 10px;
    background-position: 0 -68px;
}
.search a{
    float: left;
    width: 80px;
    height: 24px;
    color:#333;
    letter-spacing: 4px;
    line-height: 22px;
    text-align:center;
    text-decoration: none;
    background-position: 0 -90px;
    margin: 4px 0 0 10px;
}
.search a:hover{
    color: #f60;
    background-position: -80px -90px;
}
.search .sub{
    position: absolute;
    top:26px;
    left: 40px;
    color: #fff;
    width: 198px;
    background: #2b2b2b;
    border: 1px solid #fff;
    
}
.search .sub li{
    height: 25px;
    line-height: 24px;
    cursor: pointer;
    padding-left: 10px;
    margin-bottom:-1px;
    border-bottom: 1px dotted #fff;
}
.search .sub li.hover{
    background: #8b8b8b;
}
</style>
